module.exports = __webpack_public_path__ + "img/comilla.602c9bba.svg";